import { render, staticRenderFns } from "./NewUsers.vue?vue&type=template&id=12d1d2fa&"
import script from "./NewUsers.vue?vue&type=script&lang=js&"
export * from "./NewUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports